(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('FirebaseTokenDialogController', FirebaseTokenDialogController);

    FirebaseTokenDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'FirebaseToken', 'Customer'];

    function FirebaseTokenDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, FirebaseToken, Customer) {
        var vm = this;

        vm.firebaseToken = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.customers = Customer.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.firebaseToken.id !== null) {
                FirebaseToken.update(vm.firebaseToken, onSaveSuccess, onSaveError);
            } else {
                FirebaseToken.save(vm.firebaseToken, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:firebaseTokenUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.lastModifiedDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
